var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ion-button',{attrs:{"disabled":!_vm.$store.state.online_status},on:{"click":_vm.addContact}},[_c('ion-icon',{attrs:{"name":"add"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }